var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5603 8.1885L10.0603 0.688504C9.77905 0.407412 9.39766 0.249512 9.00001 0.249512C8.60236 0.249512 8.22097 0.407412 7.9397 0.688504L0.439697 8.1885C0.299732 8.32743 0.188783 8.49279 0.1133 8.67498C0.0378174 8.85717 -0.00069249 9.05255 9.42514e-06 9.24975V18.2498C9.42514e-06 18.4487 0.0790272 18.6394 0.219679 18.7801C0.360332 18.9207 0.551097 18.9998 0.750009 18.9998H6.75001C6.94892 18.9998 7.13969 18.9207 7.28034 18.7801C7.42099 18.6394 7.50001 18.4487 7.50001 18.2498V12.9998H10.5V18.2498C10.5 18.4487 10.579 18.6394 10.7197 18.7801C10.8603 18.9207 11.0511 18.9998 11.25 18.9998H17.25C17.4489 18.9998 17.6397 18.9207 17.7803 18.7801C17.921 18.6394 18 18.4487 18 18.2498V9.24975C18.0007 9.05255 17.9622 8.85717 17.8867 8.67498C17.8112 8.49279 17.7003 8.32743 17.5603 8.1885ZM16.5 17.4998H12V12.2498C12 12.0508 11.921 11.8601 11.7803 11.7194C11.6397 11.5788 11.4489 11.4998 11.25 11.4998H6.75001C6.5511 11.4998 6.36033 11.5788 6.21968 11.7194C6.07903 11.8601 6.00001 12.0508 6.00001 12.2498V17.4998H1.50001V9.24975L9.00001 1.74975L16.5 9.24975V17.4998Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.18aa87374131e21ced0de09699bee253.svg";
export { ForwardRef as ReactComponent };